export default __webpack_public_path__ + "static/Bitrate_Test_11_WDRMODE_0_1920000-1f7c96b77772d9fac8824c85c1d1625d.avif";